import styled from 'styled-components'

import { IconProps } from '@/components/Icons'
import BaseSvg from '@/components/Icons/BaseSvg'

const StyledIcon = styled<any>(BaseSvg)`
  width: 20px;
  height: 20px;
`
const UIView = (props: IconProps) => (
  <StyledIcon viewBox="0 0 48 48" fill="none" {...props}>
    <path
      fill="#002AB4"
      fillRule="evenodd"
      d="M4.5 12a6 6 0 0 1 6-6h27a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6h-27a6 6 0 0 1-6-6V12Zm6-3a3 3 0 0 0-3 3v3h33v-3a3 3 0 0 0-3-3h-27Zm30 9h-33v18a3 3 0 0 0 3 3h27a3 3 0 0 0 3-3V18ZM9 12a1.5 1.5 0 0 1 1.5-1.5h.015a1.5 1.5 0 0 1 1.5 1.5v.015a1.5 1.5 0 0 1-1.5 1.5H10.5a1.5 1.5 0 0 1-1.5-1.5V12Zm4.5 0a1.5 1.5 0 0 1 1.5-1.5h.015a1.5 1.5 0 0 1 1.5 1.5v.015a1.5 1.5 0 0 1-1.5 1.5H15a1.5 1.5 0 0 1-1.5-1.5V12Zm4.5 0a1.5 1.5 0 0 1 1.5-1.5h.015a1.5 1.5 0 0 1 1.5 1.5v.015a1.5 1.5 0 0 1-1.5 1.5H19.5a1.5 1.5 0 0 1-1.5-1.5V12Z"
      clipRule="evenodd"
    />
  </StyledIcon>
)

UIView.displayName = 'UIView'
export default UIView
